var map = {
	"./Statistics/StatisticsManage.vue": [
		"149d",
		"chunk-2ffaa9e1"
	],
	"./Statistics/comprehensiveResults.vue": [
		"0ba5",
		"chunk-f57eac44"
	],
	"./Statistics/daily.vue": [
		"5fdc",
		"chunk-33fd6bbc"
	],
	"./Statistics/finalTerm.vue": [
		"650a",
		"chunk-0f8b70ee"
	],
	"./Statistics/midTerm.vue": [
		"b365",
		"chunk-62a6d6b2"
	],
	"./Statistics/quiz.vue": [
		"37ab",
		"chunk-3497354c"
	],
	"./Statistics/statisticsHeaderCom.vue": [
		"03f6",
		"chunk-5e6a181c"
	],
	"./Statistics/statisticsNavLeftCom.vue": [
		"71b1",
		"chunk-56867ff0"
	],
	"./Statistics/weekCom.vue": [
		"7861",
		"chunk-d1902f14"
	],
	"./achievementStatistics/ComprehensiveResults.vue": [
		"ebf4",
		"chunk-c9d3e7dc"
	],
	"./achievementStatistics/Daily.vue": [
		"d918",
		"chunk-45dbaaa0"
	],
	"./achievementStatistics/FinalTerm.vue": [
		"cdba",
		"chunk-43898bf8"
	],
	"./achievementStatistics/Manage.vue": [
		"355f",
		"chunk-411b209a"
	],
	"./achievementStatistics/MidTerm.vue": [
		"7189",
		"chunk-c48ba3f4"
	],
	"./achievementStatistics/Quiz.vue": [
		"ef5df",
		"chunk-4495f457"
	],
	"./achievementStatistics/TheQuiz.vue": [
		"2ede",
		"chunk-35f58987"
	],
	"./achievementStatistics/TheSubject.vue": [
		"b348",
		"chunk-21375476"
	],
	"./achievementStatistics/TheSubjectType.vue": [
		"c6d0",
		"chunk-01ebeeb0"
	],
	"./achievementStatistics/TheWeek.vue": [
		"a2f2",
		"chunk-4a272af4"
	],
	"./approvals/Approval.vue": [
		"60f3",
		"chunk-2d0cedbd"
	],
	"./approvals/ApprovalsManage.vue": [
		"38ee",
		"chunk-4f86702a"
	],
	"./approvals/Notice.vue": [
		"9b42",
		"chunk-0a91bbdc"
	],
	"./approvals/Record.vue": [
		"fc71",
		"chunk-2d23794d"
	],
	"./campus/CampusList.vue": [
		"c7b8",
		"chunk-2d217c40"
	],
	"./campus/CampusManage.vue": [
		"0e53",
		"chunk-2cfacf59"
	],
	"./class/ClassList.vue": [
		"4bfe",
		"chunk-4e5ea7a8"
	],
	"./class/ClassManage.vue": [
		"aa9b",
		"chunk-07a7147a"
	],
	"./class/TheClassRoster.vue": [
		"d45d",
		"chunk-27503e95"
	],
	"./grades/GradesManage.vue": [
		"73e1",
		"chunk-2dd74384"
	],
	"./grades/RegularGrades.vue": [
		"46fd",
		"chunk-645e56d9",
		"chunk-20994c0c"
	],
	"./grades/TermGrades.vue": [
		"4e78",
		"chunk-017e845a"
	],
	"./grades/TermGradesClass.vue": [
		"4c84",
		"chunk-2ed39ce0"
	],
	"./grades/TheRegularAdvisor.vue": [
		"43ad",
		"chunk-09a873c2"
	],
	"./grades/TheRegularAttendance.vue": [
		"e1cd",
		"chunk-7f5e67be"
	],
	"./grades/TheRegularBasic.vue": [
		"4ce9",
		"chunk-645e56d9"
	],
	"./grades/TheRegularQuiz.vue": [
		"56b5",
		"chunk-e27fbaae"
	],
	"./grades/gradeClassStudent.vue": [
		"ad04",
		"chunk-35b6c43a"
	],
	"./grades/gradesSwitch.vue": [
		"2998",
		"chunk-645e56d9",
		"chunk-20994c0c",
		"chunk-2ba9bb48",
		"chunk-35b6c43a",
		"chunk-647adbf6"
	],
	"./grades/theGradesClass.vue": [
		"8949",
		"chunk-6a7ff61c"
	],
	"./grades/theGradesStudent.vue": [
		"0ff4",
		"chunk-2ba9bb48"
	],
	"./home/index.vue": [
		"7abe",
		"chunk-4c79a387"
	],
	"./layout/AuxiliaryHeader.vue": [
		"b5d5"
	],
	"./layout/AuxiliaryLayout.vue": [
		"fac7"
	],
	"./layout/DefaultHeader.vue": [
		"6eaa"
	],
	"./layout/DefaultLayout.vue": [
		"3799"
	],
	"./layout/DefaultSidebar.vue": [
		"1983"
	],
	"./layout/Page404.vue": [
		"ceb3"
	],
	"./login/Login.vue": [
		"ede4"
	],
	"./login/LoginHeader.vue": [
		"7d2e"
	],
	"./login/ThePasswordReset.vue": [
		"ae5a"
	],
	"./login/TheSignIn.vue": [
		"1e9b"
	],
	"./report/GradeClass.vue": [
		"14af",
		"chunk-683ae3f1"
	],
	"./report/GradeClassStudent.vue": [
		"a322",
		"chunk-2bb47296"
	],
	"./report/OfficalTranscriptSwitch.vue": [
		"70ba",
		"chunk-928aedfe"
	],
	"./report/ReportManage.vue": [
		"f7fb",
		"chunk-c7caccc2"
	],
	"./report/ScoreReports.vue": [
		"2272",
		"chunk-10e9d1bc"
	],
	"./report/TermPerformanceSwitch.vue": [
		"6558",
		"chunk-5984fc3b"
	],
	"./report/TheOfficalTranscriptClass.vue": [
		"f5b8",
		"chunk-2c8cc048"
	],
	"./report/TheOfficalTranscriptClassStudent.vue": [
		"fce2",
		"chunk-2624c4b3"
	],
	"./report/TheOfficalTranscriptStudent.vue": [
		"9be8",
		"chunk-ec31ca22"
	],
	"./report/TheTermPerformanceClass.vue": [
		"e89e",
		"chunk-1cdfb607"
	],
	"./report/TheTermPerformanceClassStudent.vue": [
		"7e87",
		"chunk-2d9ec279"
	],
	"./report/TheTermPerformanceStudent.vue": [
		"2e16",
		"chunk-0051e635"
	],
	"./report/TheTranscriptClass.vue": [
		"1409",
		"chunk-3c6ef3f5"
	],
	"./report/TheTranscriptClassStudent.vue": [
		"b3aa",
		"chunk-3c2bb3a0"
	],
	"./report/TheTranscriptStudent.vue": [
		"eaeb",
		"chunk-399f9b10"
	],
	"./report/TranscriptSwitch.vue": [
		"406d",
		"chunk-399f9b10",
		"chunk-3c2bb3a0",
		"chunk-5069574c"
	],
	"./scholarship/ScholarshipManage.vue": [
		"cf13",
		"chunk-3b82a9e7"
	],
	"./scholarship/ScholarshipSwitch.vue": [
		"d9f9",
		"chunk-00d6ca50",
		"chunk-dfb3c698",
		"chunk-81a391b2"
	],
	"./scholarship/ThePunishmentStudentRecord.vue": [
		"4a63",
		"chunk-2d0cb720"
	],
	"./scholarship/TheScholarshipClass.vue": [
		"2418",
		"chunk-c14c8940"
	],
	"./scholarship/TheScholarshipClassStudent.vue": [
		"fe40",
		"chunk-dfb3c698",
		"chunk-c55c0802"
	],
	"./scholarship/TheScholarshipStudent.vue": [
		"59e3",
		"chunk-00d6ca50"
	],
	"./scholarship/TheScholarshipStudentRecord.vue": [
		"cf52",
		"chunk-2d222736"
	],
	"./staff/DepartmentList.vue": [
		"fa9d",
		"chunk-2d23723c"
	],
	"./staff/StaffList.vue": [
		"8316",
		"chunk-1670cb9d"
	],
	"./staff/StaffManage.vue": [
		"0abe",
		"chunk-133e1a18"
	],
	"./staff/Subjects.vue": [
		"36b1",
		"chunk-01a66c0e"
	],
	"./student/StudentList.vue": [
		"fc91",
		"chunk-4ba64e21"
	],
	"./student/StudentManage.vue": [
		"2fbd",
		"chunk-28983956"
	],
	"./timetable/ClassTimetableList.vue": [
		"7e73",
		"chunk-3e395b1f"
	],
	"./timetable/TeacherTimetableList.vue": [
		"86d1",
		"chunk-00b4394a"
	],
	"./timetable/TimetableManage.vue": [
		"037d",
		"chunk-65b0227c"
	],
	"./verification/ModifyBasicGrades.vue": [
		"4910"
	],
	"./verification/ModifyFeedback.vue": [
		"93a3"
	],
	"./verification/ModifyGrade.vue": [
		"0299"
	],
	"./verification/ModifyQuizGrades.vue": [
		"13f5"
	],
	"./week/weekList.vue": [
		"17e5",
		"chunk-67e5389e"
	],
	"./week/weekManage.vue": [
		"8f9e",
		"chunk-2387dfd9"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;